<div class='m-16'>
	<mat-progress-bar *ngIf='loading' mode='indeterminate'></mat-progress-bar>
	<mat-accordion>
		<integration-block 
			*ngFor='let tourOperator of tourOperators; trackBy:trackByIndex;'
			[tourOperator]="tourOperator"
			(reload)="loadTourOperators($event)",
			(updated)="integrationUpdated($event, tourOperator)"
			(create)="createTripPackageIntegration(tourOperator)"
		></integration-block>
	</mat-accordion>
</div>
